import { render, staticRenderFns } from "./help-support-ticket.vue?vue&type=template&id=1e0eaa2c&scoped=true&lang=pug"
import script from "./help-support-ticket.vue?vue&type=script&lang=ts"
export * from "./help-support-ticket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0eaa2c",
  null
  
)

export default component.exports